import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { ChevronLeftIcon } from '@radix-ui/react-icons';
import { IconButton } from '@producer/ui-kit';

interface ToolBarProps {
  title?: string;

  onBack?: () => void;
}

export const ToolBar: React.FC<PropsWithChildren<ToolBarProps>> = ({ title, onBack, children }) => (
  <Container>
    {(onBack || title) && (
      <Left>
        {onBack && (
          <IconButton
            icon={<ChevronLeftIcon color="var(--color-grayscale-anti-flash-white)" />}
            onClick={onBack}
          />
        )}

        {title && <h3>{title}</h3>}
      </Left>
    )}

    {children}
  </Container>
);

export const Container = styled.div`
  height: 4rem;
  min-height: 4rem;
  border-bottom: 1px var(--content-border-color) solid;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.6rem;
`;

const Left = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.8rem;
  align-items: center;
`;

export const Tools = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.8rem;
  color: var(--color-texts-high-contrast);

  & button:not(div#download-share-button button) {
    background-color: var(--color-surfaces-bg-elevation-1);
    color: var(--color-texts-high-contrast);

    & svg {
      width: 1.6rem;
      height: 1.6rem;
      stroke: unset;
      fill: unset;
      color: var(--color-texts-high-contrast);
    }

    &:hover:enabled,
    &:focus:enabled,
    &:active:enabled {
      background-color: var(--color-surfaces-bg-elevation-2);

      & > svg {
        stroke: unset;
        fill: unset;
      }
    }
  }
`;
